<template>
<div class="main">
<button class="close-btn" @click="handleClose">
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
</button>
<div class="body">
<h2><strong>[낭만만세력]서비스 이용약관</strong></h2><br/>
<section class="section">
<h3><strong>제 1장 총칙</strong></h3>

<p><strong>제 1 조 (목적)</strong></p>
<p>안녕하세요? 낭만만세력을 이용해 주셔서 감사합니다. 본 약관은 단감소프트가 운영하는 인터넷, 모바일을 이용한 낭만만세력(이하 "낭만만세력"이라 한다)에서 제공하는 관련 서비스(이하 “서비스”라 한다)를 이용하는 데 필요한 낭만만세력과 이용자의 권리, 의무 및 책임사항, 이용조건 및 절차 등 기본적인 사항을 규정하고 있으므로 주의 깊게 읽어 주시기 바랍니다.</p><br>

    <p><strong>제 2 조 (용어의 정의)</strong></p>
    <p>이 약관에서 사용하는 용어의 정의는 아래와 같습니다.</p>
    <ol>
        <li> “낭만만세력”이라 함은 “콘텐츠” 산업과 관련된 경제활동을 영위하는 자로서 콘텐츠 및 제반서비스를 제공하는 자를 말합니다.</li>
        <li> “이용자”라 함은 “낭만만세력”의 앱 및 웹에 접속하여 이 약관에 따라 “낭만만세력”이 제공하는 “콘텐츠” 및 제반 서비스를 이용하는 회원 및 비회원을 말합니다.</li>
        <li> “회원”이라 함은 “낭만만세력”과 이용계약을 체결하고 “이용자” 아이디(ID)를 부여 받은 “이용자”로서 “낭만만세력”의 정보를 지속적으로 제공받으며 “낭만만세력”이 제공하는 서비스를 지속적으로 이용할 수 있는 자를 말합니다.</li>
        <li> “비회원”이라 함은 “회원”이 아니면서 “낭만만세력”이 제공하는 서비스를 이용하는 자를 말합니다.</li>
        <li> “콘텐츠”라 함은 정보통신망이용촉진 및 정보보호 등에 관한 법률 제 2조 제 1항 제 1호의 규정에 의한 정보통신망에서 사용되는 부호·문자·음성·음향·이미지 또는 영상 등으로 표현된 자료 또는 정보로서, 그 보존 및 이용에 있어서 효용을 높일 수 있도록 전자적 형태로 제작 또는 처리된 것을 말합니다.</li>
        <li> “아이디(ID)”라 함은 “회원”의 식별과 서비스이용을 위하여 “회원”이 정하고 “낭만만세력”이 승인하는 문자 또는 숫자의 조합을 말합니다.</li>
        <li> “비밀번호(PASSWORD)”라 함은 “회원”이 부여받은 “아이디”와 일치되는 “회원”임을 확인하고 비밀보호를 위해 “회원” 자신이 정한 문자 또는 숫자의 조합을 말합니다.</li>
    </ol><br>

    <p><strong>제 3 조 (신원정보 동의 제공)</strong></p>
    <p>“낭만만세력”은 이 약관의 내용, 상호, 대표자 성명, 영업소 소재지 주소(소비자의 불만을 처리할 수 있는 곳의 주소를 포함), 전화번호, 모사전송번호, 전자우편주소, 사업자등록번호, 통신판매업 신고번호 및 개인정보관리책임자 등을 이용자가 쉽게 알 수 있도록 온라인 서비스 초기화면에 게시합니다. 다만, 약관은 이용자가 연결화면을 통하여 볼 수 있도록 할 수 있습니다.</p><br>

    <p><strong>제 4 조 (약관의 게시 등)</strong></p>
    <ul class="no-bullets">
        <li><span class="circle-num">①</span> “낭만만세력”은 이 약관을 “회원”이 그 전부를 인쇄할 수 있고 거래과정에서 해당 약관의 내용을 확인할 수 있도록 기술적 조치를 취합니다.</li>
        <li><span class="circle-num">②</span> “낭만만세력”은 “이용자”가 “낭만만세력”과 이 약관의 내용에 관하여 질의 및 응답할 수 있도록 기술적 장치를 설치합니다.</li>
        <li><span class="circle-num">③</span> “낭만만세력”은 “이용자”가 약관에 동의하기에 앞서 약관에 정해져 있는 내용 중 청약철회, 환불조건 등과 같은 중요한 내용을 이용자가 쉽게 이해할 수 있도록 별도의 연결화면 또는 팝업화면 등을 제공하여 “이용자”의 확인을 구합니다.</li>
    </ul><br>

    <p><strong>제 5 조 (약관의 개정 등)</strong></p>
    <ul class="no-bullets">
        <li><span class="circle-num">①</span> “낭만만세력”은 온라인 디지털 콘텐츠산업 발전법, 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제에 관한 법률 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.</li>
        <li><span class="circle-num">②</span> “낭만만세력”이 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 서비스초기화면에 그 적용일자 7일 이전부터 적용일 후 상당한 기간 동안 공지하고, 기존회원에게는 개정약관을 전자우편주소로 전송합니다.</li>
        <li><span class="circle-num">③</span> “낭만만세력”이 약관을 개정할 경우에는 개정약관 공지 후 개정약관의 적용에 대한 “이용자”의 동의 여부를 확인합니다. “이용자”가 개정약관의 적용에 동의하지 않는 경우 “낭만만세력” 또는 “이용자”는 콘텐츠 이용계약을 해지할 수 있습니다. 이때, “낭만만세력”은 계약해지로 인하여 “이용자”가 입은 손해를 배상합니다.</li>
    </ul><br>

<p><strong>제 6 조 (약관의 해석)</strong></p>
<p>이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 온라인 디지털 콘텐츠산업 발전법, 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제에 관한 법률, 정보통신부장관이 정하는 디지털 콘텐츠이용자보호지침, 기타 관계법령 또는 상관례에 따릅니다.</p><br>
</section>
<section class="section">
<h3><strong>제 2장 회원가입</strong></h3>

<p><strong>제 7 조 (회원가입)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> 회원가입은 “이용자”가 약관의 내용에 대하여 동의를 하고 회원가입신청을 한 후 “낭만만세력”이 이러한 신청에 대하여 승낙함으로써 체결됩니다.</li>
    <li><span class="circle-num">②</span> 회원가입신청서에는 다음 사항을 기재해야 합니다. 1호 내지 3호의 사항은 필수사항이며, 그 외의 사항은 선택사항 입니다.
        <ol>
            <li> “회원”의 성명 또는 인터넷상 개인식별번호</li>
            <li> “아이디”와 “비밀번호”</li>
            <li> 휴대폰 번호</li>
            <li> 기타 “낭만만세력”이 필요하다고 인정하는 사항</li>
        </ol>
    </li>
    <li><span class="circle-num">③</span> “낭만만세력”은 상기 “이용자”의 신청에 대하여 회원가입을 승낙함을 원칙으로 합니다. 다만, “낭만만세력”은 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않을 수 있습니다.
        <ol>
            <li> 가입신청자가 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우</li>
            <li> 실명이 아니거나 타인의 명의를 이용한 경우</li>
            <li> 허위의 정보를 기재하거나, 낭만만세력이 제시하는 내용을 기재하지 않은 경우</li>
            <li> 이용자의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우</li>
        </ol>
    </li>
    <li><span class="circle-num">④</span> “낭만만세력”은 서비스 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.</li>
    <li><span class="circle-num">⑤</span> 제 3항과 제 4항에 따라 회원가입신청의 승낙을 하지 아니하거나 유보한 경우, “낭만만세력”은 이를 신청자에게 알려야 합니다. “낭만만세력”의 귀책사유 없이 신청자에게 통지할 수 없는 경우에는 예외로 합니다.</li>
    <li><span class="circle-num">⑥</span> 회원가입계약의 성립 시기는 “낭만만세력”의 승낙이 “이용자”에게 도달한 시점으로 합니다.</li>
</ul><br>

<p><strong>제 8 조 (미성년자의 회원가입에 관한 특칙)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> 만 14세 미만의 “이용자”는 개인정보의 수집 및 이용목적에 대하여 충분히 숙지하고 부모 등 법정대리인의 동의를 얻은 후에 회원가입을 신청하고 본인의 개인정보를 제공하여야 합니다.</li>
    <li><span class="circle-num">②</span> 낭만만세력은 부모 등 법정대리인의 동의에 대한 확인절차를 거치지 않은 14세 미만 이용자에 대하여는 가입을 취소 또는 불허합니다.</li>
    <li><span class="circle-num">③</span> 만 14세 미만 “이용자”의 부모 등 법정대리인은 아동에 대한 개인정보의 열람, 정정, 갱신을 요청하거나 회원가입에 대한 동의를 철회할 수 있으며, 이러한 경우에 “낭만만세력”은 지체 없이 필요한 조치를 취해야 합니다.</li>
</ul><br>

<p><strong>제 9 조 (회원정보의 변경)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> “회원”은 개인정보관리화면을 통하여 언제든지 자신의 개인정보를 열람하고 수정할 수 있습니다.</li>
    <li><span class="circle-num">②</span> “회원”은 회원가입신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 전자우편 기타 방법으로 “낭만만세력”에 대하여 그 변경사항을 알려야 합니다.</li>
    <li><span class="circle-num">③</span> 제 2항의 변경사항을 “낭만만세력”에 알리지 않아 발생한 불이익에 대하여 “낭만만세력”은 책임지지 않습니다.</li>
</ul><br>

<p><strong>제 10 조 ("회원"의 "아이디" 및 "비밀번호"의 관리에 대한 의무)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> “회원”의 “아이디”와 “비밀번호”에 관한 관리책임은 “회원”에게 있으며, 이를 제 3자가 이용하도록 하여서는 안 됩니다.</li>
    <li><span class="circle-num">②</span> “회원”은 “아이디” 및 “비밀번호”가 도용되거나 제 3자에 의해 사용되고 있음을 인지한 경우에는 이를 즉시 “낭만만세력”에 통지하고 “낭만만세력”의 안내에 따라야 합니다.</li>
    <li><span class="circle-num">③</span> 제 2항의 경우에 해당 “회원”이 “낭만만세력”에 그 사실을 통지하지 않거나, 통지한 경우에도 “낭만만세력”의 안내에 따르지 않아 발생한 불이익에 대하여 “낭만만세력”은 책임지지 않습니다.</li>
</ul><br>

<p><strong>제 11 조 ("회원"에 대한 통지)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> “낭만만세력”이 “회원”에 대한 통지를 하는 경우 “회원”이 지정한 전자우편주소로 할 수 있습니다.</li>
    <li><span class="circle-num">②</span> “낭만만세력”은 “회원” 전체에 대한 통지의 경우 7일 이상 “낭만만세력”의 게시판에 게시함으로써 제 1항의 통지에 갈음할 수 있습니다. 다만, “회원” 본인의 거래와 관련하여 중대한 영향을 미치는 사항에 대하여는 제 1항의 통지를 합니다.</li>
</ul><br>

<p><strong>제 12 조 (회원탈퇴 및 자격 상실 등)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> “회원”은 “낭만만세력”에 언제든지 탈퇴를 요청할 수 있으며 “낭만만세력”은 즉시 회원탈퇴를 처리합니다.</li>
    <li><span class="circle-num">②</span> “회원”이 다음 각호의 사유에 해당하는 경우, “낭만만세력”은 회원자격을 제한 및 정지시킬 수 있습니다.
        <ol>
            <li> 가입신청 시에 허위내용을 등록한 경우</li>
            <li> “낭만만세력”의 서비스이용대금, 기타 “낭만만세력”의 서비스이용에 관련하여 회원이 부담하는 채무를 기일에 이행하지 않는 경우</li>
            <li> 다른 사람의 “낭만만세력”의 서비스이용을 방해하거나 그 정보를 도용하는 등 전자상거래 질서를 위협하는 경우</li>
            <li> “낭만만세력”을 이용하여 법령 또는 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우</li>
        </ol>
    </li>
    <li><span class="circle-num">③</span> “낭만만세력”이 회원자격을 제한·정지시킨 후, 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 “낭만만세력”은 회원자격을 상실시킬 수 있습니다.</li>
    <li><span class="circle-num">④</span> “낭만만세력”이 회원자격을 상실시키는 경우에는 회원등록을 말소합니다. 이 경우 “회원”에게 이를 통지하고, 회원등록 말소 전에 최소한 30일 이상의 기간을 정하여 소명할 기회를 부여합니다.</li>
</ul><br>
</section>
<section class="section">
<h3><strong>제 3장 콘텐츠이용계약</strong></h3>

<p><strong>제 13 조 ("콘텐츠"의 내용 등의 게시)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> “낭만만세력”은 다음 사항을 해당 “콘텐츠”의 이용초기화면이나 그 포장에 “이용자”가 알기 쉽게 표시합니다.
        <ol>
            <li> “콘텐츠”의 명칭 또는 제호</li>
            <li> “콘텐츠”의 제작 및 표시 연월일</li>
            <li> “콘텐츠” 제작자의 성명(법인인 경우에는 법인의 명칭), 주소, 전화번호</li>
            <li> “콘텐츠”의 내용, 이용방법, 이용료 기타 이용조건</li>
        </ol>
    </li>
    <li><span class="circle-num">②</span> “낭만만세력”은 “콘텐츠”별 이용가능기기 및 이용에 필요한 최소한의 기술사양에 관한 정보를 계약체결과정에서 “이용자”에게 제공합니다.</li>
</ul><br>

<p><strong>제 14 조 (이용계약의 성립 등)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> “이용자”는 “낭만만세력”이 제공하는 다음 또는 이와 유사한 절차에 의하여 이용신청을 합니다. “낭만만세력”은 계약 체결 전에 각 호의 사항에 관하여 “이용자”가 정확하게 이해하고 실수 또는 착오 없이 거래할 수 있도록 정보를 제공합니다.
        <ul>
            <li> “콘텐츠” 목록의 열람 및 선택</li>
            <li> 성명, 전화번호(또는 이동전화번호), 전자우편주소 등의 입력</li>
            <li> 약관내용, 청약철회가 불가능한 “콘텐츠”에 대해 “낭만만세력”이 취한 조치에 관련한 내용에 대한 확인</li>
            <li> 이 약관에 동의하고 위 제 3호의 사항을 확인하거나 거부하는 표시(예, 마우스 클릭)</li>
            <li> “콘텐츠”의 이용신청에 관한 확인 또는 “낭만만세력”의 확인에 대한 동의</li>
        </ul>
    </li>
    <li><span class="circle-num">②</span> “낭만만세력”은 “이용자”의 이용신청이 다음 각 호에 해당하는 경우에는 승낙하지 않거나 승낙을 유보할 수 있습니다.
        <ol>
            <li> 실명이 아니거나 타인의 명의를 이용한 경우</li>
            <li> 허위의 정보를 기재하거나, “낭만만세력”이 제시하는 내용을 기재하지 않은 경우</li>
            <li> 미성년자가 청소년보호법에 의해서 이용이 금지되는 “콘텐츠”를 이용하고자 하는 경우</li>
            <li> 서비스 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우</li>
        </ol>
    </li>
    <li><span class="circle-num">③</span> “낭만만세력”의 승낙이 제 16조 제 1항의 수신확인통지형태로 “이용자”에게 도달한 시점에 계약이 성립한 것으로 봅니다.</li>
    <li><span class="circle-num">④</span> “낭만만세력”의 승낙의 의사표시에는 “이용자”의 이용신청에 대한 확인 및 서비스제공 가능여부, 이용신청의 정정·취소 등에 관한 정보 등을 포함합니다.</li>
</ul><br>

<p><strong>제 15 조 (미성년자 이용계약에 관한 특칙)</strong></p>
<p>“낭만만세력”은 만 20세 미만의 미성년이용자가 유료서비스를 이용하고자 하는 경우에 부모 등 법정 대리인의 동의를 얻거나, 계약체결 후 추인을 얻지 않으면 미성년자 본인 또는 법정대리인이 그 계약을 취소할 수 있다는 내용을 계약체결 전에 고지하는 조치를 취합니다.</p><br>

<p><strong>제 16 조 (수신확인통지·이용신청 변경 및 취소)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> “낭만만세력”은 “이용자”의 이용신청이 있는 경우 “이용자”에게 수신확인통지를 합니다.</li>
    <li><span class="circle-num">②</span> 수신확인통지를 받은 “이용자”는 의사표시의 불일치 등이 있는 경우에는 수신확인통지를 받은 후 즉시 이용신청 변경 및 취소를 요청할 수 있고, “낭만만세력”은 서비스제공 전에 “이용자”의 요청이 있는 경우에는 지체 없이 그 요청에 따라 처리하여야 합니다. 다만, 이미 대금을 지불한 경우에는 청약철회 등에 관한 제 27조의 규정에 따릅니다.</li>
</ul><br>

<p><strong>제 17 조 (낭만만세력의 의무)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> “낭만만세력”은 법령과 이 약관이 정하는 권리의 행사와 의무의 이행을 신의에 좇아 성실하게 하여야 합니다.</li>
    <li><span class="circle-num">②</span> “낭만만세력”은 “이용자”가 안전하게 “콘텐츠”를 이용할 수 있도록 개인정보(신용정보 포함)보호를 위해 보안시스템을 갖추어야 하며 개인정보보호정책을 공시하고 준수합니다.</li>
    <li><span class="circle-num">③</span> “낭만만세력”은 “이용자”가 콘텐츠이용 및 그 대금내역을 수시로 확인할 수 있도록 조치합니다.</li>
    <li><span class="circle-num">④</span> “낭만만세력”은 콘텐츠이용과 관련하여 “이용자”로부터 제기된 의견이나 불만이 정당하다고 인정할 경우 이를 지체 없이 처리합니다. 이용자가 제기한 의견이나 불만사항에 대해서는 게시판을 활용하거나 전자우편 등을 통하여 그 처리과정 및 결과를 전달합니다.</li>
    <li><span class="circle-num">⑤</span> “낭만만세력”은 이 약관에서 정한 의무 위반으로 인하여 “이용자”가 입은 손해를 배상합니다.</li>
</ul><br>

<p><strong>제 18 조 ("이용자"의 의무)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> “이용자”는 다음 행위를 하여서는 안 됩니다.
        <ol>
            <li> 신청 또는 변경 시 허위내용의 기재</li>
            <li> 타인의 정보 도용</li>
            <li> “낭만만세력”에 게시된 정보의 변경</li>
            <li> “낭만만세력”이 금지한 정보(컴퓨터 프로그램 등)의 송신 또는 게시</li>
            <li> “낭만만세력” 및 기타 제 3자의 저작권 등 지적재산권에 대한 침해</li>
            <li> “낭만만세력” 및 기타 제 3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
            <li> 외설 또는 폭력적인 말이나 글, 화상, 음향, 기타 공서양속에 반하는 정보를 “낭만만세력”의 사이트에 공개 또는 게시하는 행위</li>
            <li> 기타 불법적이거나 부당한 행위</li>
        </ol>
    </li>
    <li><span class="circle-num">②</span> “이용자”는 관계법령, 이 약관의 규정, 이용안내 및 “콘텐츠”와 관련하여 공지한 주의사항, “낭만만세력”이 통지하는 사항 등을 준수하여야 하며, 기타 “낭만만세력”의 업무에 방해되는 행위를 하여서는 안 됩니다.</li>
</ul><br>

<p><strong>제 19 조 (지급방법)</strong></p>
<p>“콘텐츠”의 이용에 대한 대금지급방법은 다음 각 호의 방법 중 가능한 방법으로 할 수 있습니다. 다만, “낭만만세력”은 “이용자”의 지급방법에 대하여 어떠한 명목의 수수료도 추가하여 징수하지 않습니다.</p>
<ol>
    <li> 폰뱅킹, 인터넷뱅킹, 메일 뱅킹 등의 각종 계좌이체</li>
    <li> 선불카드, 직불카드, 신용카드 등의 각종 카드결제</li>
    <li> 온라인무통장입금</li>
    <li> 전자화폐에 의한 결제</li>
    <li> 마일리지 등 “낭만만세력”이 지급한 포인트에 의한 결제</li>
    <li> “낭만만세력”와 계약을 맺었거나 “낭만만세력”이 인정한 상품권에 의한 결제</li>
    <li> 전화 또는 휴대전화를 이용한 결제</li>
    <li> 기타 전자적 지급방법에 의한 대금지급 등</li>
</ol><br>

<p><strong>제 20 조 (콘텐츠서비스의 제공 및 중단)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> 콘텐츠서비스는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다.</li>
    <li><span class="circle-num">②</span> “낭만만세력”은 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 콘텐츠서비스의 제공을 일시적으로 중단할 수 있습니다. 이 경우 “낭만만세력”은 제 11조[“회원”에 대한 통지]에 정한 방법으로 “이용자”에게 통지합니다. 다만, “낭만만세력”이 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.</li>
    <li><span class="circle-num">③</span> “낭만만세력”은 상당한 이유 없이 콘텐츠서비스의 제공이 일시적으로 중단됨으로 인하여 “이용자”가 입은 손해에 대하여 배상합니다. 다만, “낭만만세력”이 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.</li>
    <li><span class="circle-num">④</span> “낭만만세력”은 콘텐츠서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검시간은 서비스제공화면에 공지한 바에 따릅니다.</li>
    <li><span class="circle-num">⑤</span> 사업종목의 전환, 사업의 포기, 업체 간의 통합 등의 이유로 콘텐츠서비스를 제공할 수 없게 되는 경우에는 “낭만만세력”은 제 11조[“회원”에 대한 통지]에 정한 방법으로 “이용자”에게 통지하고 당초 “낭만만세력”에서 제시한 조건에 따라 “이용자”에게 보상합니다. 다만, “낭만만세력”이 보상기준 등을 고지하지 아니하거나, 고지한 보상기준이 적절하지 않은 경우에는 “이용자”들의 마일리지 또는 적립금 등을 현물 또는 현금으로 “이용자”에게 지급합니다.</li>
</ul><br>

<p><strong>제 21 조 (콘텐츠서비스의 변경)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> “낭만만세력”은 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 콘텐츠서비스를 변경할 수 있습니다.</li>
    <li><span class="circle-num">②</span> “낭만만세력”은 콘텐츠서비스의 내용, 이용방법, 이용시간을 변경할 경우에 변경사유, 변경될 콘텐츠서비스의 내용 및 제공일자 등을 그 변경 전 7일 이상 해당 콘텐츠초기화면에 게시합니다.</li>
    <li><span class="circle-num">③</span> 제 2항의 경우에 변경된 내용이 중대하거나 “이용자”에게 불리한 경우에는 “낭만만세력”이 해당 콘텐츠서비스를 제공받는 “이용자”에게 제 11조[“회원”에 대한 통지]에 정한 방법으로 통지하고 동의를 받습니다. 이때, “낭만만세력”은 동의를 거절한 “이용자”에 대하여는 변경 전 서비스를 제공합니다. 다만, 그러한 서비스 제공이 불가능할 경우 계약을 해지할 수 있습니다.</li>
    <li><span class="circle-num">④</span> “낭만만세력”은 제 1항에 의한 서비스의 변경 및 제 3항에 의한 계약의 해지로 인하여 “이용자”가 입은 손해를 배상합니다.</li>
</ul><br>

<p><strong>제 22 조 (정보의 제공 및 광고의 게재)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> “낭만만세력”은 “이용자”가 콘텐츠이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 전자우편 등의 방법으로 “회원”에게 제공할 수 있습니다. 다만, “회원”은 언제든지 전자우편 등을 통하여 수신 거절을 할 수 있습니다.</li>
    <li><span class="circle-num">②</span> 제 1항의 정보를 전화 및 모사전송기기에 의하여 전송하려고 하는 경우에는 “회원”의 사전 동의를 받아서 전송합니다.</li>
    <li><span class="circle-num">③</span> “낭만만세력”은 “콘텐츠”서비스 제공과 관련하여 콘텐츠화면, 홈페이지, 전자우편 등에 광고를 게재할 수 있습니다. 광고가 게재된 전자우편 등을 수신한 “회원”은 수신거절을 “낭만만세력”에게 할 수 있습니다.</li>
</ul><br>

<p><strong>제 23 조 (게시물의 삭제)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> “낭만만세력”은 게시판에 정보통신망이용촉진 및 정보보호 등에 관한 법률을 위반한 청소년유해매체물이 게시되어 있는 경우에는 이를 지체 없이 삭제 합니다. 다만, 19세 이상의 “이용자”만 이용할 수 있는 게시판은 예외로 합니다.</li>
    <li><span class="circle-num">②</span> “낭만만세력”이 운영하는 게시판 등에 게시된 정보로 인하여 법률상 이익이 침해된 자는 “낭만만세력”에게 당해 정보의 삭제 또는 반박내용의 게재를 요청할 수 있습니다. 이 경우 “낭만만세력”은 지체 없이 필요한 조치를 취하고 이를 즉시 신청인에게 통지합니다.</li>
</ul><br>

<p><strong>제 24 조 (저작권 등의 귀속)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> “낭만만세력”이 작성한 저작물에 대한 저작권 기타 지적재산권은 “낭만만세력”에 귀속합니다.</li>
    <li><span class="circle-num">②</span> “낭만만세력”이 제공하는 서비스 중 제휴계약에 의해 제공되는 저작물에 대한 저작권 기타 지적재산권은 해당 제공업체에 귀속합니다.</li>
    <li><span class="circle-num">③</span> “이용자”는 “낭만만세력”이 제공하는 서비스를 이용함으로써 얻은 정보 중 “낭만만세력” 또는 제공업체에 지적재산권이 귀속된 정보를 “낭만만세력” 또는 제공업체의 사전승낙 없이 복제, 전송, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제 3자에게 이용하게 하여서는 안 됩니다.</li>
    <li><span class="circle-num">④</span> “낭만만세력”은 약정에 따라 “이용자”의 저작물을 사용하는 경우 당해 “이용자”의 허락을 받습니다.</li>
</ul><br>

<p><strong>제 25 조 (개인정보보호)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> “낭만만세력”은 제 7조 제 2항의 신청서 기재사항 이외에 “이용자”의 콘텐츠이용에 필요한 최소한의 정보를 수집할 수 있습니다. 이를 위해 “낭만만세력”이 문의한 사항에 관해 “이용자”는 진실한 내용을 성실하게 고지하여야 합니다.</li>
    <li><span class="circle-num">②</span> “낭만만세력”이 “이용자”의 개인 식별이 가능한 “개인정보”를 수집하는 때에는 당해 “이용자”의 동의를 받습니다.</li>
    <li><span class="circle-num">③</span> “낭만만세력”은 “이용자”가 이용신청 등에서 제공한 정보와 제 1항에 의하여 수집한 정보를 당해 “이용자”의 동의 없이 목적 외로 이용하거나 제 3자에게 제공할 수 없으며, 이를 위반한 경우에 모든 책임은 “낭만만세력”이 집니다. 다만, 다음의 경우에는 예외로 합니다.
        <ol>
            <li> 통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우</li>
            <li> “콘텐츠” 제공에 따른 요금정산을 위하여 필요한 경우</li>
            <li> 도용방지를 위하여 본인확인에 필요한 경우</li>
            <li> 약관의 규정 또는 법령에 의하여 필요한 불가피한 사유가 있는 경우</li>
        </ol>
    </li>
    <li><span class="circle-num">④</span> “낭만만세력”이 제 2항과 제 3항에 의해 “이용자”의 동의를 받아야 하는 경우에는 “개인정보”관리책임자의 신원(소속, 성명 및 전화번호 기타 연락처), 정보의 수집목적 및 이용목적, 제 3자에 대한 정보제공관련사항(제공받는 자, 제공목적 및 제공할 정보의 내용)등에 관하여 정보통신망이용촉진 및 정보보호 등에 관한 법률 제 22조 제 2항이 규정한 사항을 명시하고 고지하여야 합니다.</li>
    <li><span class="circle-num">⑤</span> “이용자”는 언제든지 제 3항의 동의를 임의로 철회할 수 있습니다.</li>
    <li><span class="circle-num">⑥</span> “이용자”는 언제든지 “낭만만세력”이 가지고 있는 자신의 “개인정보”에 대해 열람 및 오류의 정정을 요구할 수 있으며, “낭만만세력”은 이에 대해 지체 없이 필요한 조치를 취할 의무를 집니다. “이용자”가 오류의 정정을 요구한 경우에는 “낭만만세력”은 그 오류를 정정할 때까지 당해 “개인정보”를 이용하지 않습니다.</li>
    <li><span class="circle-num">⑦</span> “낭만만세력”은 개인정보보호를 위하여 관리자를 한정하여 그 수를 최소화하며, 신용카드, 은행계좌 등을 포함한 “이용자”의 “개인정보”의 분실, 도난, 유출, 변조 등으로 인한 “이용자”의 손해에 대하여 책임을 집니다.</li>
    <li><span class="circle-num">⑧</span> “낭만만세력” 또는 그로부터 “개인정보”를 제공받은 자는 “이용자”가 동의한 범위 내에서 “개인정보”를 사용할 수 있으며, 목적이 달성된 경우에는 당해 “개인정보”를 지체 없이 파기합니다.</li>
    <li><span class="circle-num">⑨</span> “낭만만세력”은 정보통신망이용촉진 및 정보보호에 관한 법률 등 관계 법령이 정하는 바에 따라 “이용자”의 “개인정보”를 보호하기 위해 노력합니다. “개인정보”의 보호 및 사용에 대해서는 관련법령 및 “낭만만세력”의 개인정보보호정책이 적용됩니다.</li>
</ul><br>
</section>
<section class="section">
<h3><strong>제 4장 콘텐츠이용계약의 청약철회, 계약해제·해지 및 이용제한</strong></h3>

<p><strong>제 26 조 ("이용자"의 청약철회와 계약해제·해지)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> “낭만만세력”과 “콘텐츠”의 이용에 관한 계약을 체결한 “이용자”는 수신확인의 통지를 받은 날로부터 7일 이내에는 청약의 철회를 할 수 있습니다. 다만, “낭만만세력”이 다음 각 호 중 하나의 조치를 취한 경우에는 “이용자”의 청약철회권이 제한될 수 있습니다.
        <ol>
            <li> 청약의 철회가 불가능한 “콘텐츠”에 대한 사실을 표시사항에 포함한 경우</li>
            <li> 시용상품을 제공한 경우</li>
            <li> 한시적 또는 일부이용 등의 방법을 제공한 경우</li>
        </ol>
    </li>
    <li><span class="circle-num">②</span> “이용자”는 다음 각 호의 사유가 있을 때에는 당해 “콘텐츠”를 공급받은 날로부터 3월 이내 또는 그 사실을 안 날 또는 알 수 있었던 날부터 30일 이내에 콘텐츠이용계약을 해제·해지할 수 있습니다.
        <ol>
            <li> 이용계약에서 약정한 “콘텐츠”가 제공되지 않는 경우</li>
            <li> 제공되는 “콘텐츠”가 표시·광고 등과 상이하거나 현저한 차이가 있는 경우</li>
            <li> 기타 “콘텐츠”의 결함으로 정상적인 이용이 현저히 불가능한 경우</li>
        </ol>
    </li>
    <li><span class="circle-num">③</span> 제 1항의 청약철회와 제 2항의 계약해제·해지는 “이용자”가 전화, 전자우편 또는 모사전송으로 “낭만만세력”에 그 의사를 표시한 때에 효력이 발생합니다.</li>
    <li><span class="circle-num">④</span> “낭만만세력”은 제 3항에 따라 “이용자”가 표시한 청약철회 또는 계약해제·해지의 의사표시를 수신한 후 지체 없이 이러한 사실을 “이용자”에게 회신합니다.</li>
    <li><span class="circle-num">⑤</span> “이용자”는 제 2항의 사유로 계약해제·해지의 의사표시를 하기 전에 상당한 기간을 정하여 완전한 “콘텐츠” 혹은 서비스이용의 하자에 대한 치유를 요구할 수 있습니다.</li>
</ul><br>

<p><strong>제 27 조 ("이용자"의 청약철회와 계약해제·해지의 효과)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> “낭만만세력”은 “이용자”가 청약철회의 의사표시를 한 날로부터 또는 “이용자”에게 계약해제·해지의 의사표시에 대하여 회신한 날로부터 3영업일 이내에 대금의 결제와 동일한 방법으로 이를 환급하여야 하며, 동일한 방법으로 환불이 불가능할 때에는 이를 사전에 고지하여야 합니다. 이 경우 “낭만만세력”이 “이용자”에게 환급을 지연한 때에는 그 지연기간에 대하여 공정거래위원회가 정하여 고시하는 지연이자율을 곱하여 산정한 지연이자를 지급합니다.</li>
    <li><span class="circle-num">②</span> “낭만만세력”이 제 1항에 따라 환급할 경우에 “이용자”가 서비스이용으로부터 얻은 이익에 해당하는 금액을 공제하고 환급할 수 있습니다.</li>
    <li><span class="circle-num">③</span> “낭만만세력”은 위 대금을 환급함에 있어서 “이용자”가 신용카드 또는 전자화폐 등의 결제수단으로 대금을 지급한 때에는 지체 없이 당해 결제수단을 제공한 사업자로 하여금 대금 청구를 정지 또는 취소하도록 요청합니다.</li>
    <li><span class="circle-num">④</span> “낭만만세력”, “콘텐츠 등의 대금을 지급 받은 자” 또는 “이용자와 콘텐츠이용계약을 체결한 자“가 동일인이 아닌 경우에 각자는 청약철회 또는 계약해제·해지로 인한 대금환급과 관련한 의무의 이행에 있어서 연대하여 책임을 집니다.</li>
    <li><span class="circle-num">⑤</span> “낭만만세력”은 “이용자”에게 청약철회를 이유로 위약금 또는 손해배상을 청구하지 않습니다. 그러나 “이용자”의 계약해제·해지는 손해배상의 청구에 영향을 미치지 않습니다.</li>
</ul><br>

<p><strong>제 28 조 (낭만만세력의 계약해제·해지 및 이용제한)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> “낭만만세력”은 “이용자”가 제 12조 제 2항에서 정한 행위를 하였을 경우 사전통지 없이 계약을 해제·해지하거나 또는 기간을 정하여 서비스이용을 제한할 수 있습니다.</li>
    <li><span class="circle-num">②</span> 제 1항의 해제·해지는 “낭만만세력”이 자신이 정한 통지방법에 따라 “이용자”에게 그 의사를 표시한 때에 효력이 발생합니다.</li>
    <li><span class="circle-num">③</span> “낭만만세력”의 해제·해지 및 이용제한에 대하여 “이용자”는 “낭만만세력”이 정한 절차에 따라 이의신청을 할 수 있습니다. 이때 이의가 정당하다고 “낭만만세력”이 인정하는 경우, “낭만만세력”은 즉시 서비스의 이용을 재개합니다.</li>
</ul><br>

<p><strong>제 29 조 (낭만만세력의 계약해제·해지의 효과)</strong></p>
<p>“이용자”의 귀책사유에 따른 이용계약의 해제·해지의 효과는 제 27조를 준용합니다. 다만, “낭만만세력”은 “이용자”에 대하여 계약해제·해지의 의사표시를 한 날로부터 7영업일 이내에 대금의 결제와 동일한 방법으로 이를 환급합니다.</p><br>

<h3><strong>제 5장 과오금, 피해보상 등</strong></h3>

<p><strong>제 30 조 (과오금)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> “낭만만세력”은 과오금이 발생한 경우 이용대금의 결제와 동일한 방법으로 과오금 전액을 환불하여야 합니다. 다만, 동일한 방법으로 환불이 불가능할 때는 이를 사전에 고지합니다.</li>
    <li><span class="circle-num">②</span> “낭만만세력”의 책임 있는 사유로 과오금이 발생한 경우 “낭만만세력”은 계약비용, 수수료 등에 관계없이 과오금 전액을 환불합니다. 다만, “이용자”의 책임 있는 사유로 과오금이 발생한 경우, “낭만만세력”이 과오금을 환불하는 데 소요되는 비용은 합리적인 범위 내에서 “이용자”가 부담하여야 합니다.</li>
    <li><span class="circle-num">③</span> 낭만만세력은 “이용자”가 주장하는 과오금에 대해 환불을 거부할 경우에 정당하게 이용대금이 부과되었음을 입증할 책임을 집니다.</li>
    <li><span class="circle-num">④</span> “낭만만세력”은 과오금의 환불절차를 디지털콘텐츠이용자보호지침에 따라 처리합니다.</li>
</ul><br>

<p><strong>제 31 조 (콘텐츠하자 등에 의한 이용자피해보상)</strong></p>
<p>“낭만만세력”은 콘텐츠하자 등에 의한 이용자피해보상의 기준·범위·방법 및 절차에 관한 사항을 디지털콘텐츠이용자보호지침에 따라 처리합니다.</p><br>

<p><strong>제 32 조 (면책조항)</strong></p>
<ul class="no-bullets">
    <li><span class="circle-num">①</span> “낭만만세력”은 천재지변 또는 이에 준하는 불가항력으로 인하여 “콘텐츠”를 제공할 수 없는 경우에는 “콘텐츠” 제공에 관한 책임이 면제됩니다.</li>
    <li><span class="circle-num">②</span> “낭만만세력”은 “이용자”의 귀책사유로 인한 콘텐츠이용의 장애에 대하여는 책임을 지지 않습니다.</li>
    <li><span class="circle-num">③</span> “낭만만세력”은 “회원”이 “콘텐츠”와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.</li>
    <li><span class="circle-num">④</span> “낭만만세력”은 “이용자” 상호 간 또는 “이용자”와 제 3자 간에 “콘텐츠”를 매개로 하여 발생한 분쟁 등에 대하여 책임을 지지 않습니다.</li>
</ul><br>

<p><strong>제 33 조 (분쟁의 해결)</strong></p>
<p>“낭만만세력”은 분쟁이 발생하였을 경우에 “이용자”가 제기하는 정당한 의견이나 불만을 반영하여 적절하고 신속한 조치를 취합니다. 다만, 신속한 처리가 곤란한 경우에 “낭만만세력”은 “이용자”에게 그 사유와 처리일정을 통보합니다.</p><br>

<p><strong>법인명 : (주)단감소프트</strong></p>
<p>사업자등록번호 : 303-81-79157<br>
대표자 : 임성웅<br>
주소 : 경기도 수원시 영통구 신원로 55 (신동) 테크트리 영통 지식산업센터 709,710, 817호<br>
이메일 : info@dangamsoft.com</p>
</section>
</div>
</div>

</template>
<script setup>
definePage({ meta: { layout: 'empty' } })

const handleClose = () => {
  window.close()
}
</script>

<style lang="scss" scoped>
.main{
    font-family: Pretendard;
    color: #333;
    margin: 50px 150px 50px 150px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    position: relative;
    .body{
        width: 900px;
    }
}
.close-btn {
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    color: #333;
}
.section{
    color: #333;
    margin-bottom: 30px;

    ul {
    list-style-type: disc;
    padding-left: 30px;
    margin: 0;
    }
    ol {
    list-style-type: decimal;
    padding-left: 30px;
    margin: 0;
    }

    li {
    // font-size: 16px;
    line-height: 1.5;
    margin-bottom: 5px;
    }
    .circle-num{
        font-size: 10px;
    }
    .no-bullets{
        list-style-type: none !important;
    }
}

@media (max-width: 768px) {
    .main {
        margin: 20px 16px;
        .body {
            width: 100%;
        }
    }
    .close-btn {
        display: block;
    }
}
</style>